/* eslint-disable react/display-name */
import * as React from 'react';

const HeartFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M8,15H8L2.1,8.8h0a4,4,0,0,1,0-5.6,3.53,3.53,0,0,1,5.3,0l.6.5.5-.6a3.53,3.53,0,0,1,5.3,0,4,4,0,0,1,0,5.6h0L8,15Zm0,0H8L2.1,8.8h0a4,4,0,0,1,0-5.6,3.53,3.53,0,0,1,5.3,0l.6.5.5-.6a3.53,3.53,0,0,1,5.3,0,4,4,0,0,1,0,5.6h0L8,15Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default HeartFilled;
